export const CONTACT_ROLES: Record<string, string> = {
  stakeHolder: 'Stakeholder',
  serviceOwner: 'Service Owner',
  tenantOwner: 'Tenant Owner',
  onboardingSupport: 'Onboarding Support',
};
